import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { formValues, schema } from "./validations";
import { useEffect } from "react";
import { TERM, DAYS } from "../consts";

const useFilter = ({
  filterData,
  setFilterData,
  onCancel,
}: {
  filterData: any;
  setFilterData: React.Dispatch<React.SetStateAction<any>>;
  onCancel: () => void;
}) => {
  const isMobile = useIsMobile();

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [TERM]: "",
      [DAYS]: "",
    },
  });

  useEffect(() => {
    if (filterData) {
      form.reset({
        [TERM]: filterData?.[TERM] || "",
        [DAYS]: filterData?.[DAYS] || "",
      });
    }
  }, [filterData]);

  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: formValues) => {
    let _data = removeEmptyFields(data);
    _data = setEmptyFieldsToNull(data);
    if(_data.term){
      _data.taskTerm=_data.term;
      delete _data.term;
    } 
    setFilterData(_data);
    onCancel();
  };

  const onClear = () => {
    setFilterData(null);
    form.reset({
      [TERM]: "",
      [DAYS]: ""
    })
  };

  return {
    form,
    onSubmit,
    requiredFields,
    isMobile,
    onClear,
  };
};

export default useFilter;
